import { render } from 'react-dom';
import Wrapper from './components/Wrapper';

document.title = window.conf.LAYOUT.TITLE || "Portal"

render(<Wrapper />, document.getElementById('root'))